import { Button } from '@artstorefronts/ui';
import { useNavigate } from 'react-router-dom';
import { useMutation, gql, useQuery } from '@apollo/client';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

import { COMPLETION_TYPES_QUERY } from '../../../graphql/queries';
import { useGoBack } from '~/hooks/useGoBack';

import AdminLayout from '../../../components/AdminLayout';
import SparkForm from '../../../components/SparkForm';

const QUERY = gql`
  query Models {
    models {
      id
      provider
      name
    }
  }
`;

const CREATE_MUTATION = gql`
  mutation CreateCompletionType($input: CreateCompletionTypeInput!) {
    createCompletionType(input: $input) {
      id
      permissionKey
      name
      icon
      order
      promptData
      description
      planNames
      enabled
      expiresAt
      additionalInfo
      signupHeaderText
      signupFormLabelText
      signupButtonText
      linkOutUrl
      isLinkOutNewWindow
      isLinkOut
    }
  }
`;

function DataWrapper() {
  const { data, loading } = useQuery(QUERY);

  const models = data?.models;

  if (loading || !models) {
    return null;
  }

  return (
    <>
      <AdminSparkAdd models={data?.models} />
    </>
  );
}

function AdminSparkAdd({ models }: any) {
  const { t } = useTranslation('admin');
  const { t: tc } = useTranslation('common');
  const navigate = useNavigate();
  const [createSpark] = useMutation(CREATE_MUTATION, {
    refetchQueries: [{ query: COMPLETION_TYPES_QUERY }],
    awaitRefetchQueries: true,
  });

  const goBack = useGoBack();

  async function handleSubmit(data: any) {
    try {
      await createSpark({
        variables: {
          input: {
            ...data,
          },
        },
      });

      toast.success(t('sparks.create.toast-success'));
      navigate(`/admin/sparks`);
    } catch (error) {
      console.error('Failed to create spark:', error);
      toast.error(t('sparks.create.toast-error'));
    }
  }

  return (
    <AdminLayout
      title={t('sparks.create.page-title')}
      description={t('sparks.create.page-description')}
      action={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => goBack({ fallback: '/admin/sparks' })}>
            {tc('cancel')}
          </Button>
          <Button type="submit" form="spark-form">
            {t('sparks.create.submit')}
          </Button>
        </div>
      }
    >
      <div className="w-full">
        <SparkForm id="spark-form" onSubmit={handleSubmit} models={models} />
      </div>
    </AdminLayout>
  );
}

export default DataWrapper;
